import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import { ArrowBack, WhatsApp } from "@mui/icons-material";
import TextField from "@mui/material/TextField";
import { Button, Select, MenuItem, FormControl } from "@mui/material";
import Header from "./common/header";
import useApi from "../hooks/useApi";
import {
  sendOtpApi,
  verifyOtpApi,
  guestCheckInSubmitApi,
  userSignUpApi,
} from "../api/controller/accounts/guest";
import { route } from "preact-router";

const ContainerWrapper = styled("div")`
  width: 95%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  background-color: #000;
  color: #fff;
  box-sizing: border-box;
`;

const Container = styled("div")`
  width: 95%;
  max-width: 600px;
  padding: 20px;
  color: #fff;
  background-color: black;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  position: relative;

  .arrowBack {
    position: absolute;
    top: 38px;
    left: 1px;
    height: 40px;
    width: 40px;
    display: flex;
    background: #1a1a1a;
    justify-content: center;
    align-items: center;
    border-radius: 999px;
    cursor: pointer;

    @media (max-width: 924px) {
      left: -10px;
    }
    @media (max-width: 480px) {
      left: -2px;
    }
  }

  .headerText {
    margin-bottom: 20px;
    font-size: 32px;
    font-weight: 700;
    margin-top: 20px;
    color: #fff;
    @media (max-width: 480px) {
      max-width: 250px;
      margin-left: 10px;
    }
  }
`;

const FormSection = styled("div")`
  width: 90%;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  margin-top: 20px;

  .form-group {
    margin-bottom: 20px;
  }

  .inputText {
    color: #f7f7f7;
    font-size: 16px;
    line-height: 24px;
    text-align: left;
    padding-right: 20px;
    font-weight: 500;
    @media only screen and (max-width: 924px) {
      text-align: center;
      padding-bottom: 10px;
    }
  }

  .inputContainer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: center;
    width: 100%;
    & > * {
      flex: 1;
      width: 100%;
    }
    @media only screen and (max-width: 600px) {
      flex-direction: column;
      justify-content: center;
    }
  }

  .inputField {
    height: 36px !important;
    .MuiSelect-select {
      display: flex;
    }
  }
`;

const WhiteBorderTextField = styled(TextField)`
  & .MuiOutlinedInput-root {
    height: 36px !important;

    & fieldset {
      border-color: white !important;
      border-radius: 8px;
      height: 36px !important;
    }
    &.Mui-focused fieldset {
      height: 36px !important;
      border-color: white !important;
    }
  }
`;

const WhiteBorderSelect = styled(Select)`
  height: 36px !important;
  color: white;

  & .MuiOutlinedInput-notchedOutline {
    border-color: white !important;
    border-radius: 8px;
  }

  &:hover .MuiOutlinedInput-notchedOutline {
    border-color: white !important;
  }

  &.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: white !important;
  }

  & .MuiSelect-icon {
    color: white;
  }

  & .MuiSelect-select {
    padding: 8px 14px;
    text-align: center;
    font-family: Poppins;
  }
`;

const GetOTPButton = styled(Button)`
  background: rgb(103, 65, 217);
  width: 100%;
  min-width: 200px;
  text-transform: none;
  line-height: 60px;
  padding: 0px 8px;
  border: 0;
  box-sizing: border-box;
  border-radius: 16px;
  box-shadow: -1px 1px 10px #f0c3f1;
  color: white;
  font-size: 18px;
  font-weight: 600;
  outline: none;
  font-family: Poppins;
  margin-top: 20px;

  &:hover {
    border: #f0c3f1 1px solid;
    background-color: #6741d9;
  }
  &:disabled {
    background-color: #808080;
    color: #000000;
    box-shadow: -1px 1px 10px #f0c3f1;
  }
`;

const removeCountryCode = (mobileNumber) => {
  if (!mobileNumber) return "";

  // Remove all spaces first
  let cleanNumber = mobileNumber.replaceAll(" ", "");

  // Remove common country codes
  if (cleanNumber.startsWith("+91")) {
    cleanNumber = cleanNumber.substring(3);
  } else if (cleanNumber.startsWith("91") && cleanNumber.length > 10) {
    cleanNumber = cleanNumber.substring(2);
  } else if (cleanNumber.startsWith("+")) {
    // Remove any other country code (+ followed by 1-3 digits)
    cleanNumber = cleanNumber.replace(/^\+\d{1,3}/, "");
  }

  return cleanNumber;
};

const GuestDetails = ({ onBack, selectedMobileNumber = "" }) => {
  const [mobileNumber, setMobileNumber] = useState(
    selectedMobileNumber ? removeCountryCode(selectedMobileNumber) : ""
  );
  const [currentStep, setCurrentStep] = useState("mobile");
  const [userType, setUserType] = useState(null); // 'existing' or 'new'

  // Update mobile number when selectedMobileNumber prop changes
  useEffect(() => {
    console.log(
      "GuestDetails - selectedMobileNumber prop:",
      selectedMobileNumber
    );
    if (selectedMobileNumber) {
      const cleanedNumber = removeCountryCode(selectedMobileNumber);
      console.log("GuestDetails - cleaned number:", cleanedNumber);
      setMobileNumber(cleanedNumber);
    }
  }, [selectedMobileNumber]);
  const [numberOfGuests, setNumberOfGuests] = useState("");
  const [countryCode, setCountryCode] = useState("+91");
  const [timer, setTimer] = useState(0);
  const [isTimerActive, setIsTimerActive] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 400);

  // API hooks
  const sendOtpRequest = useApi();
  const verifyOtpRequest = useApi();
  const guestCheckInRequest = useApi();
  const userSignUpRequest = useApi();

  // Store user ID from OTP verification
  const [userId, setUserId] = useState(null);
  const [signUpSuccess, setSignUpSuccess] = useState(false);

  // Country code options
  const countryCodeOptions = [
    { value: "+91", label: "🇮🇳 +91" },
    { value: "+1", label: "🇺🇸 +1" },
  ];

  // Form fields
  const [otp, setOtp] = useState("");
  const [name, setName] = useState("");
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("");

  // Focus states for floating labels
  const [nameFocused, setNameFocused] = useState(false);
  const [ageFocused, setAgeFocused] = useState(false);
  const [genderFocused, setGenderFocused] = useState(false);

  const handleCountryCodeChange = (e) => {
    setCountryCode(e.target.value);
  };

  const getNumericValue = (value) => {
    return value.replace(/\D/g, "");
  };

  // Handle send OTP response
  useEffect(() => {
    if (sendOtpRequest.data && sendOtpRequest.data.status === 200) {
      setUserType("existing");
      setCurrentStep("otp");
      startTimer();
    }

    // Check if response indicates user doesn't exist
    if (sendOtpRequest.data && sendOtpRequest.data.status === 404) {
      setUserType("new");
      setCurrentStep("signup");
    }
  }, [sendOtpRequest.data]);

  // Handle OTP verification response
  useEffect(() => {
    if (
      verifyOtpRequest.data &&
      verifyOtpRequest.data.data &&
      verifyOtpRequest.data.data.is_verified
    ) {
      setUserId(verifyOtpRequest.data.data.id);
      // Go to check-in step after OTP verification
      setCurrentStep("checkin");
    }
  }, [verifyOtpRequest.data]);

  // Handle signup response
  useEffect(() => {
    if (userSignUpRequest.data && userSignUpRequest.data.data) {
      console.log("✅ Signup successful:", userSignUpRequest.data.data);
      setSignUpSuccess(true);

      // After successful signup, automatically send OTP (same pattern as login)
      setTimeout(() => {
        const fullMobile = countryCode.replace("+", "%2B") + mobileNumber;
        sendOtpApi(sendOtpRequest.request, fullMobile);
        setCurrentStep("otp");
        startTimer();
      }, 100);
    }
  }, [userSignUpRequest.data]);

  // Handle guest check-in response
  useEffect(() => {
    if (guestCheckInRequest.data && guestCheckInRequest.data.status === 200) {
      // Navigate back to check-in preset or show success message
      if (typeof window !== "undefined") {
        window.location.reload();
      }
      onBack();
    }
  }, [guestCheckInRequest.data]);

  // Handle API errors
  useEffect(() => {
    // Multiple ways to detect 404 - User does not exist
    const is404Error =
      sendOtpRequest.error &&
      (sendOtpRequest.errorCode === 404 ||
        sendOtpRequest.error.status === 404 ||
        sendOtpRequest.error.code === 404 ||
        (sendOtpRequest.error.message &&
          sendOtpRequest.error.message.includes("User doesn't exist")) ||
        (sendOtpRequest.error.response &&
          sendOtpRequest.error.response.status === 404) ||
        (typeof sendOtpRequest.error === "string" &&
          sendOtpRequest.error.includes("User doesn't exist")));

    if (is404Error) {
      setUserType("new");
      setCurrentStep("signup");
    }
  }, [sendOtpRequest.error, sendOtpRequest.errorCode, sendOtpRequest.data]);

  // Handle signup API errors
  useEffect(() => {
    if (
      userSignUpRequest.error &&
      (userSignUpRequest.errorCode === 422 ||
        userSignUpRequest.error.status === 422)
    ) {
      setUserType("existing");
      setCurrentStep("mobile");
    }
  }, [userSignUpRequest.error, userSignUpRequest.errorCode]);

  // Timer effect for OTP
  React.useEffect(() => {
    let interval = null;
    if (isTimerActive && timer > 0) {
      interval = setInterval(() => {
        setTimer((timer) => timer - 1);
      }, 1000);
    } else if (timer === 0) {
      setIsTimerActive(false);
    }
    return () => clearInterval(interval);
  }, [isTimerActive, timer]);

  // Handle screen resize for responsive layout
  React.useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 400);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const startTimer = () => {
    setTimer(30);
    setIsTimerActive(true);
  };

  const handleResendOTP = () => {
    // Prevent multiple calls if already loading
    if (sendOtpRequest.loading) {
      return;
    }

    console.log("Resending OTP to:", mobileNumber);
    const fullMobile = countryCode.replace("+", "%2B") + mobileNumber;
    sendOtpApi(sendOtpRequest.request, fullMobile);
    startTimer(); // Restart the timer
  };

  const handleGetOTP = () => {
    // Prevent multiple calls if already loading
    if (sendOtpRequest.loading || mobileNumber.length !== 10) {
      return;
    }

    console.log("Getting OTP for:", mobileNumber);
    const fullMobile = countryCode.replace("+", "%2B") + mobileNumber;
    sendOtpApi(sendOtpRequest.request, fullMobile);
  };

  const handleNext = () => {
    // Prevent multiple calls if already loading or invalid data
    if (userSignUpRequest.loading || !name || mobileNumber.length !== 10) {
      return;
    }

    console.log("Signing up new user:", {
      mobile: countryCode + mobileNumber,
      name: name,
      age: age ? parseInt(age) : null,
      gender: gender || null,
    });

    // Call signup API
    userSignUpApi(userSignUpRequest.request, {
      mobile: countryCode + mobileNumber,
      name: name,
      age: age ? parseInt(age) : null,
      gender: gender || null,
    });
  };

  const handleOTPSubmit = () => {
    // Prevent multiple calls if already loading or invalid OTP
    if (verifyOtpRequest.loading || otp.length !== 6) {
      return;
    }

    console.log("Verifying OTP:", {
      whatsappNumber: mobileNumber,
      name: name,
      age: age,
      gender: gender,
      otp: otp,
    });

    const fullMobile = countryCode + mobileNumber;
    verifyOtpApi(verifyOtpRequest.request, {
      mobile: fullMobile,
      otp: otp,
    });
  };

  const handleCheckIn = () => {
    // Prevent multiple calls if already loading or invalid data
    if (guestCheckInRequest.loading || !numberOfGuests || !userId) {
      return;
    }

    console.log("Submitting check-in data:", {
      user: userId,
      total_guests: parseInt(numberOfGuests),
    });

    // Make API call to submit guest check-in
    guestCheckInSubmitApi(guestCheckInRequest.request, {
      user: userId,
      total_guests: parseInt(numberOfGuests),
    });
  };

  const handleBackClick = () => {
    if (typeof onBack === "function") {
      onBack();
    }
  };

  const renderMobileStep = () => (
    <FormSection>
      <div className="inputContainer">
        <div className="inputText">Guest's WhatsApp Number:</div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            backgroundColor: "#1C1C1E",
            borderRadius: "16px",
            padding: "12px 8px",
            border: "1px solid #25D366",
            boxSizing: "border-box",
            width: "100%",
            maxWidth: "100%",
            overflow: "hidden",
          }}
        >
          <div>
            <select
              value={countryCode}
              onChange={handleCountryCodeChange}
              className="countrySelect"
              style={{
                width: "70px",
                borderRadius: "16px",
                backgroundColor: "#1C1C1E",
                color: "white",
                border: "none",
                outline: "none",
                fontSize: "14px",
                fontFamily: "Poppins",
                boxSizing: "border-box",
              }}
            >
              {countryCodeOptions.map((option) => (
                <option
                  key={option.value}
                  value={option.value}
                  className="countryOption"
                  style={{
                    backgroundColor: "#1C1C1E",
                    color: "white",
                  }}
                >
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <WhatsApp
            style={{ fontSize: "20px", color: "#25D366", marginLeft: "5px" }}
          />

          <input
            className="countrySelect countryInput"
            placeholder="WhatsApp Number"
            type="tel"
            inputMode="numeric"
            pattern="[0-9]*"
            maxLength="10"
            style={{
              flex: 1,
              backgroundColor: "transparent",
              border: "none",
              outline: "none",
              color: "white",
              fontSize: "14px",
              fontFamily: "Poppins",
            }}
            onKeyPress={(e) => {
              // Prevent non-numeric characters
              if (
                !/[0-9]/.test(e.key) &&
                e.key !== "Backspace" &&
                e.key !== "Delete" &&
                e.key !== "Tab"
              ) {
                e.preventDefault();
              }
            }}
            onInput={(e) => {
              // Additional validation at input level
              e.target.value = e.target.value.replace(/\D/g, "");
            }}
            onChange={(e) => {
              // Only allow numbers, no characters
              const numericValue = e.target.value.replace(/\D/g, "");
              if (numericValue.length > 10) {
                setMobileNumber(numericValue.slice(0, 10));
              } else {
                setMobileNumber(numericValue);
              }
            }}
            value={mobileNumber}
          />
        </div>
      </div>

      <GetOTPButton
        variant="contained"
        onClick={handleGetOTP}
        disabled={mobileNumber.length !== 10 || sendOtpRequest.loading}
      >
        {sendOtpRequest.loading ? "Get OTP" : "Get OTP"}
      </GetOTPButton>
    </FormSection>
  );

  const renderOTPStep = () => (
    <FormSection>
      <div className="inputContainer" style={{ flexDirection: "column" }}>
        {/* Phone number display */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            backgroundColor: "#1C1C1E",
            borderRadius: "16px",
            padding: "16px",
            border: "1px solid #25D366",
            marginBottom: "20px",
            boxSizing: "border-box",
          }}
        >
          <div>
            <select
              value={countryCode}
              disabled
              style={{
                width: "70px",
                borderRadius: "16px",
                backgroundColor: "transparent",
                color: "white",
                border: "none",
                outline: "none",
                fontSize: "14px",
                fontFamily: "Poppins",
              }}
            >
              <option value={countryCode}>
                {
                  countryCodeOptions.find((opt) => opt.value === countryCode)
                    ?.label
                }
              </option>
            </select>
          </div>

          <WhatsApp
            style={{ fontSize: "20px", color: "#25D366", marginLeft: "5px" }}
          />

          <span
            style={{
              color: "white",
              fontSize: "14px",
              fontFamily: "Poppins",
              flex: 1,
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            {mobileNumber}
          </span>
        </div>

        {/* Timer/Resend and OTP input row */}
        <div
          style={{
            display: "flex",
            alignItems: "center",

            width: "100%",
            justifyContent: "space-between",
            gap: "15px",
          }}
        >
          {/* Timer or Resend Button */}
          {timer > 0 ? (
            <div
              style={{
                backgroundColor: "#666",
                borderRadius: "25px",
                display: "flex",
                alignItems: "center",
                height: "50px",
                width: "120px",
                color: "white",
                fontSize: "16px",
                fontFamily: "Poppins",
                fontWeight: "500",
                justifyContent: "center",
              }}
            >
              {timer} sec
            </div>
          ) : (
            <button
              onClick={handleResendOTP}
              disabled={sendOtpRequest.loading}
              style={{
                backgroundColor: sendOtpRequest.loading ? "#808080" : "#6741d9",
                borderRadius: "25px",
                display: "flex",
                alignItems: "center",
                height: "50px",
                width: "120px",
                color: sendOtpRequest.loading ? "#000000" : "white",
                fontSize: "16px",
                fontFamily: "Poppins",
                fontWeight: "600",
                justifyContent: "center",
                border: "none",
                cursor: sendOtpRequest.loading ? "not-allowed" : "pointer",
                outline: "none",
                transition: "all 0.3s ease",
              }}
              onMouseOver={(e) => {
                if (!sendOtpRequest.loading) {
                  e.target.style.backgroundColor = "#5a37c7";
                }
              }}
              onMouseOut={(e) => {
                if (!sendOtpRequest.loading) {
                  e.target.style.backgroundColor = "#6741d9";
                }
              }}
            >
              {sendOtpRequest.loading ? "Resend" : "Resend"}
            </button>
          )}

          {/* OTP Input */}
          <input
            placeholder="Enter OTP"
            value={otp}
            onChange={(e) =>
              setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))
            }
            style={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              width: "100%",
              maxWidth: "200px",
              backgroundColor: "transparent",
              border: "1px solid white",
              borderRadius: "16px",
              padding: "16px",
              color: "white",
              fontSize: "16px",
              fontFamily: "Poppins",
              outline: "none",
            }}
            maxLength={6}
            inputMode="numeric"
          />
        </div>
        <>
          {verifyOtpRequest.error && (
            <div
              className="errorText"
              style={{
                margin: "20px 10px 0 10px",
                fontSize: "14px",
                color: "#c4c4c4",
              }}
            >
              {verifyOtpRequest.error}, Please try again.
            </div>
          )}
        </>
      </div>

      <GetOTPButton
        variant="contained"
        onClick={handleOTPSubmit}
        disabled={otp.length !== 6 || verifyOtpRequest.loading}
      >
        {verifyOtpRequest.loading ? "Verify OTP" : "Verify OTP"}
      </GetOTPButton>
    </FormSection>
  );

  const renderSignupStep = () => (
    <FormSection>
      <div className="inputContainer" style={{ flexDirection: "column" }}>
        {/* Name field - Full width with floating label */}
        <div style={{ position: "relative", marginBottom: "20px" }}>
          <input
            value={name}
            onKeyPress={(e) => {
              // Prevent numbers and special characters except space, hyphen, apostrophe
              if (
                !/[a-zA-Z\s'-]/.test(e.key) &&
                e.key !== "Backspace" &&
                e.key !== "Delete" &&
                e.key !== "Tab"
              ) {
                e.preventDefault();
              }
            }}
            onChange={(e) => {
              // Only allow letters, spaces, and common name characters
              const value = e.target.value.replace(/[^a-zA-Z\s'-]/g, "");
              setName(value);
            }}
            onFocus={() => setNameFocused(true)}
            onBlur={() => setNameFocused(false)}
            style={{
              width: "100%",
              backgroundColor: "transparent",
              border: "1px solid white",
              borderRadius: "16px",
              padding: nameFocused || name ? "20px 16px 12px 16px" : "16px",
              color: "white",
              fontSize: "16px",
              fontFamily: "Poppins",
              outline: "none",
              boxSizing: "border-box",
            }}
          />
          <div
            style={{
              position: "absolute",
              left: "16px",
              top: nameFocused || name ? "-8px" : "16px",
              fontSize: nameFocused || name ? "12px" : "16px",
              color: "#999",
              fontFamily: "Poppins",
              backgroundColor: nameFocused || name ? "#000" : "transparent",
              padding: nameFocused || name ? "0 4px" : "0",
              zIndex: 1,
              transition: "all 0.2s ease",
              pointerEvents: "none",
            }}
          >
            Guest Name*
          </div>
        </div>

        {/* Age and Gender row - Responsive with floating labels */}
        <div
          style={{
            display: "flex",
            flexDirection: isSmallScreen ? "column" : "row",
            gap: "20px",
            marginBottom: "20px",
            flexWrap: "wrap",
          }}
        >
          {/* Age field with floating label */}
          <div
            style={{
              position: "relative",
              flex: isSmallScreen ? "1" : "1 1 120px",
              width: isSmallScreen ? "100%" : "auto",
            }}
          >
            <input
              value={age}
              onChange={(e) => {
                // Only allow numbers and limit to 99
                const numericValue = e.target.value.replace(/\D/g, "");
                const limitedValue = Math.min(
                  parseInt(numericValue) || 0,
                  99
                ).toString();
                setAge(numericValue === "" ? "" : limitedValue);
              }}
              onFocus={() => setAgeFocused(true)}
              onBlur={() => setAgeFocused(false)}
              style={{
                width: "100%",
                backgroundColor: "transparent",
                border: "1px solid white",
                borderRadius: "16px",
                padding: ageFocused || age ? "20px 16px 12px 16px" : "16px",
                color: "white",
                fontSize: "16px",
                fontFamily: "Poppins",
                outline: "none",
                boxSizing: "border-box",
              }}
              inputMode="numeric"
              maxLength={2}
            />
            <div
              style={{
                position: "absolute",
                left: "16px",
                top: ageFocused || age ? "-8px" : "16px",
                fontSize: ageFocused || age ? "12px" : "16px",
                color: "#999",
                fontFamily: "Poppins",
                backgroundColor: ageFocused || age ? "#000" : "transparent",
                padding: ageFocused || age ? "0 4px" : "0",
                zIndex: 1,
                transition: "all 0.2s ease",
                pointerEvents: "none",
              }}
            >
              Guest's Age
            </div>
          </div>

          {/* Gender field with floating label */}
          <div
            style={{
              position: "relative",
              flex: isSmallScreen ? "1" : "1 1 120px",
              width: isSmallScreen ? "100%" : "auto",
              minWidth: isSmallScreen ? "auto" : "120px",
            }}
          >
            <select
              value={gender}
              onChange={(e) => setGender(e.target.value)}
              onFocus={() => setGenderFocused(true)}
              onBlur={() => setGenderFocused(false)}
              style={{
                width: "100%",
                backgroundColor: "transparent",
                border: "1px solid white",
                borderRadius: "16px",
                padding:
                  genderFocused || gender ? "20px 16px 12px 16px" : "16px",
                color: gender ? "white" : "transparent",
                fontSize: "16px",
                fontFamily: "Poppins",
                outline: "none",
                boxSizing: "border-box",
                appearance: "none",
              }}
            >
              <option value="" disabled style={{ color: "#999" }}></option>
              <option
                value="male"
                style={{ backgroundColor: "#1C1C1E", color: "white" }}
              >
                Male
              </option>
              <option
                value="female"
                style={{ backgroundColor: "#1C1C1E", color: "white" }}
              >
                Female
              </option>
              <option
                value="other"
                style={{ backgroundColor: "#1C1C1E", color: "white" }}
              >
                Other
              </option>
            </select>
            <div
              style={{
                position: "absolute",
                left: "16px",
                top: genderFocused || gender ? "-8px" : "16px",
                fontSize: genderFocused || gender ? "12px" : "16px",
                color: "#999",
                fontFamily: "Poppins",
                backgroundColor:
                  genderFocused || gender ? "#000" : "transparent",
                padding: genderFocused || gender ? "0 4px" : "0",
                zIndex: 1,
                transition: "all 0.2s ease",
                pointerEvents: "none",
              }}
            >
              Guest's Gender
            </div>
            {/* Custom dropdown arrow */}
            <div
              style={{
                position: "absolute",
                right: "16px",
                top: "50%",
                transform: "translateY(-50%)",
                pointerEvents: "none",
                color: "white",
                fontSize: "12px",
              }}
            >
              ▼
            </div>
          </div>
        </div>

        {/* WhatsApp Number field - Full width */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            backgroundColor: "#1C1C1E",
            borderRadius: "12px",
            padding: "16px",
            border: "1px solid #25D366",

            boxSizing: "border-box",
          }}
        >
          <div>
            <select
              value={countryCode}
              disabled
              style={{
                width: "70px",
                borderRadius: "16px",
                backgroundColor: "#1C1C1E",
                color: "white",
                border: "none",
                outline: "none",
                fontSize: "14px",
                fontFamily: "Poppins",
              }}
            >
              <option value={countryCode}>
                {
                  countryCodeOptions.find((opt) => opt.value === countryCode)
                    ?.label
                }
              </option>
            </select>
          </div>

          <WhatsApp
            style={{ fontSize: "20px", color: "#25D366", marginLeft: "5px" }}
          />

          <span
            style={{
              color: "white",
              fontSize: "16px",
              fontFamily: "Poppins",
              flex: 1,
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            {mobileNumber}
          </span>
        </div>
      </div>

      <GetOTPButton
        variant="contained"
        onClick={handleNext}
        disabled={!name || userSignUpRequest.loading}
      >
        {userSignUpRequest.loading ? "Creating Account..." : "Next"}
      </GetOTPButton>
    </FormSection>
  );

  const renderCheckInStep = () => (
    <FormSection>
      <div className="inputContainer">
        {/* Question text */}
        <div className="inputText"> Total Number of Guests:</div>

        {/* Number input field */}
        <div style={{ width: "100%" }}>
          <WhiteBorderTextField
            className="inputField"
            sx={{
              input: {
                color: "white",
                textAlign: "center",
                padding: "0 20px 3px 20px !important",
                fontFamily: "poppins",
              },
            }}
            InputLabelProps={{
              style: {
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
                width: "100%",
                color: "#808080",
                textAlign: "center",
              },
            }}
            id="numberOfGuests"
            autoComplete="off"
            style={{ width: "100%" }}
            placeholder="eg: 4"
            type="number"
            variant="outlined"
            value={numberOfGuests}
            onChange={(e) => {
              if (e.target.value > 999) {
                e.target.value = "999";
              }
              setNumberOfGuests(e.target.value);
            }}
          />
        </div>
      </div>

      <GetOTPButton
        variant="contained"
        onClick={handleCheckIn}
        disabled={!numberOfGuests || guestCheckInRequest.loading}
      >
        {guestCheckInRequest.loading ? "Check-in" : "Check-in"}
      </GetOTPButton>
    </FormSection>
  );

  return (
    <ContainerWrapper>
      <Header />
      <Container>
        <div className="arrowBack" onClick={handleBackClick}>
          <ArrowBack style={{ cursor: "pointer", fontSize: "32px" }} />
        </div>
        <div className="headerText">Guest Details</div>

        {currentStep === "mobile" && renderMobileStep()}
        {currentStep === "otp" && renderOTPStep()}
        {currentStep === "signup" && renderSignupStep()}
        {currentStep === "checkin" && renderCheckInStep()}
      </Container>
    </ContainerWrapper>
  );
};

export default GuestDetails;
